import type { Category } from '@/types/Category'
import type DataResponse from '@/types/DataResponse'
import type { AxiosResponse } from 'axios'
import { http } from '../plugins/http'

export default class CategoryService {
  async index(): Promise<AxiosResponse<DataResponse<Category[]>>> {
    return await http.get<DataResponse<Category[]>>(`/api/categories`)
  }
}
